import axios from 'axios'
import authService from '../../services/auth.js'

// 设置API基本URL
const API_URL = '/api/v1'

// 初始状态
const state = {
  authStatus: false,
  token: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  userInfo:{
    real_name: '',
    nickname: '',
    email: '',
    phone_number: '',
    created_at: '',
    role: '',
  },
  userRole: '',
}

// 获取器
const getters = {
  isLoggedIn: state => !!state.token,
  userInfo: state => state.user,
  authStatus: state => state.authStatus,
  currentUserInfo: state => state.userInfo,
  currentRole: state => state.userRole
}

// 动作
const actions = {
  // 用户登录
  async login({ commit, dispatch }, credentials) {
    try {
      const formData = new FormData()
      formData.append('username', credentials.email)
      formData.append('password', credentials.password)
      
      const response = await axios.post(`${API_URL}/users/token`, formData)
      const token = response.data.access_token
      
      // 保存令牌
      localStorage.setItem('token', token)
      commit('setToken', token)
      
      // 获取用户信息
      await dispatch('fetchCurrentUser')
      
      return { success: true }
    } catch (error) {
      console.error('登录失败:', error)
      return { 
        success: false, 
        message: error.response?.data?.detail || '登录失败，请检查您的凭据'
      }
    }
  },
  
  // 用户注册
  async register({ dispatch }, userData) {
    try {
      await axios.post(`${API_URL}/users/register`, userData)
      
      // 注册成功后自动登录
      return await dispatch('login', {
        email: userData.email,
        password: userData.password
      })
    } catch (error) {
      console.error('注册失败:', error)
      return { 
        success: false, 
        message: error.response?.data?.detail || '注册失败，请稍后再试'
      }
    }
  },
  
  // 获取用户信息
  async fetchCurrentUser({ commit }) {
    try {
      const token = localStorage.getItem('token')
      if (!token) return
      
      const response = await authService.getCurrentUser()
      
      const user = response
      // 保存用户信息
      localStorage.setItem('user', user)
      commit('setUser', user)
      
      return user
    } catch (error) {
      console.error('获取用户信息失败:', error)
      // 如果令牌失效，登出用户
      if (error.response && error.response.status === 401) {
        commit('logout')
      }
    }
  },
  
  async setUserInfo({ commit }, userInfo) {
    commit('setUserInfo', userInfo)
  },

  async setAuthRole({ commit }, role) {
    commit('setAuthRole', role) 
  },

  // 用户登出
  logout({ commit }) {
    // 移除本地存储的认证信息
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    
    // 更新状态
    commit('logout')
  }
}

// 变更
const mutations = {
  setToken(state, token) {
    state.token = token
  },
  
  setUser(state, user) {
    state.user = user
  },
  
  logout(state) {
    state.token = ''
    state.user = null
  },

  setUserInfo(state, userInfo) {
    state.userInfo = { ...state.userInfo, ...userInfo }
  },

  setAuthRole(state, role) {
    state.userRole = role
  },

  setAuthStatus(state, status) {
    state.authStatus = status
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} 